var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/loading/common/src/loading-icon-props.ts
var loadingIconColorNames = ["blue", "gray"];
var loadingIconSizes = ["sm", "md", "lg"];
var loadingIconShapes = ["square", "circle"];
var loadingIconDefaultProps = {
  label: false,
  color: "blue",
  size: "md",
  shape: "square"
};
var loadingIconDefaultLabelText = "Loading...";

// components/loading/common/src/loading-icon-style-sheet.ts
import {
  StyleSheet,
  getEmotionInstance
} from "@gs-ux-uitoolkit-common/style";
import { mix } from "polished";
import { colors } from "@gs-ux-uitoolkit-common/design-system";
import {
  createComponentClassDefinitions
} from "@gs-ux-uitoolkit-common/theme";
var animationFrames = 39;
var animationFrameRate = 100 / animationFrames;
var animationFullDuration = 70 * animationFrames;
var animationFrameDuration = animationFullDuration / animationFrames;
function paperLoadingState(transform, stroke, strokeWidth) {
  return `
        transform: ${transform};
        fill: ${stroke};
        stroke: ${stroke};
        stroke-width: ${strokeWidth || 0}px;
        stroke-linecap: square; 
    `;
}
function paperCenterAnimation(colorLight, colorDark) {
  return getEmotionInstance().keyframes`
        0% {
            fill: ${colorLight};
            stroke: ${colorLight};
        }
        ${animationFrameRate * 9}% {
            fill: ${colorLight};
            stroke: ${colorLight};
        }
        ${animationFrameRate * 11}% {
            fill: ${colorDark};
            stroke: ${colorDark};
        }
        ${animationFrameRate * 29}% {
            fill: ${colorDark};
            stroke: ${colorDark};
        }
        ${animationFrameRate * 31}% {
            fill: ${colorLight};
            stroke: ${colorLight};
        }`;
}
function paperFoldAnimation(rotateY, colorLight, colorMed, colorDark) {
  const transform0 = `rotate3d(0, 0, 0, 0deg)`;
  const transform45 = `rotate3d(1, ${rotateY}, 0, 45deg)`;
  const transform90 = `rotate3d(1, ${rotateY}, 0, 90deg)`;
  const transform135 = `rotate3d(1, ${rotateY}, 0, 135deg)`;
  const transform180 = `rotate3d(1, ${rotateY}, 0, 180deg)`;
  return getEmotionInstance().keyframes`
        0% {
            ${paperLoadingState(transform0, colorLight, 2)}
        }
        ${animationFrameRate * 2}% {
            ${paperLoadingState(transform45, mix(0.25, colorLight, colorMed))};
        }
        ${animationFrameRate * 3}% {
            ${paperLoadingState(transform90, mix(0.5, colorLight, colorMed))}
        }
        ${animationFrameRate * 4}% {
            ${paperLoadingState(transform135, mix(0.75, colorLight, colorMed))}
        }
        ${animationFrameRate * 5}% {
            ${paperLoadingState(transform180, colorMed)}
        }
        ${animationFrameRate * 8}% {
            ${paperLoadingState(transform180, colorMed)}
        }
        ${animationFrameRate * 9}% {
            ${paperLoadingState(transform135, mix(0.25, colorMed, colorDark))}
        }
        ${animationFrameRate * 10}% {
            ${paperLoadingState(transform90, mix(0.5, colorMed, colorDark))}
        }
        ${animationFrameRate * 11}% {
            ${paperLoadingState(transform45, mix(0.75, colorMed, colorDark))}
        }
        ${animationFrameRate * 12}% {
            ${paperLoadingState(transform0, colorDark, 2)}
        }

        ${animationFrameRate * 20}% {
            ${paperLoadingState(transform0, colorDark, 2)}
        }
        ${animationFrameRate * 21}% {
            ${paperLoadingState(transform45, mix(0.25, colorDark, colorMed), 2)}
        }
        ${animationFrameRate * 22}% {
            ${paperLoadingState(transform90, mix(0.5, colorDark, colorMed), 2)}
        }
        ${animationFrameRate * 23}% {
            ${paperLoadingState(transform135, mix(0.75, colorDark, colorMed), 2)}
        }
        ${animationFrameRate * 24}% {
            ${paperLoadingState(transform180, colorMed)}
        }
        ${animationFrameRate * 28}% {
            ${paperLoadingState(transform180, colorMed)}
        }
        ${animationFrameRate * 29}% {
            ${paperLoadingState(transform135, mix(0.25, colorMed, colorLight))}
        }
        ${animationFrameRate * 30}% {
            ${paperLoadingState(transform90, mix(0.5, colorMed, colorLight))}
        }
        ${animationFrameRate * 31}% {
            ${paperLoadingState(transform45, mix(0.75, colorMed, colorLight))}
        }
        ${animationFrameRate * 32}% {
            ${paperLoadingState(transform0, colorLight, 2)}
        }
    `;
}
var loadingIconStyleSheet = new StyleSheet(
  "loading-icon",
  (props) => {
    var _a;
    return createComponentClassDefinitions(props, createDefaultStyledClasses, (_a = props.theme.styleOverrides) == null ? void 0 : _a.loadingIcon);
  }
);
function createDefaultStyledClasses({
  theme,
  size = loadingIconDefaultProps.size,
  color = loadingIconDefaultProps.color,
  shape = loadingIconDefaultProps.shape
}) {
  let squareColorLight = colors.blue040;
  let squareColorMedium = colors.blue060;
  let squareColorDark = colors.blue060;
  let iconOpacity = 1;
  let circleColor = theme.color.blue.bold;
  if (color === "gray") {
    squareColorLight = colors.gray010;
    squareColorMedium = colors.gray020;
    squareColorDark = colors.gray030;
    circleColor = theme.color.gray.bold;
    iconOpacity = 0.65;
  }
  const circleCircumference = 2 * Math.PI * parseInt(loadingIconSizeVariants[size].circleRadius, 10);
  const spinAnimation = getEmotionInstance().keyframes`
    0% {
        transform: rotate(0deg);
        stroke-dashoffset: ${0 * circleCircumference};
    }
    50% {
        transform: rotate(720deg);
        stroke-dashoffset: ${1 * circleCircumference};
    }
    100% {
        transform: rotate(1080deg);
        stroke-dashoffset: ${0 * circleCircumference};
    }
    `;
  const cornerAnimation = {
    animationTimingFunction: "cubic-bezier(0.55, 0.085, 0.68, 0.53)"
  };
  return {
    root: {
      display: "block",
      position: "relative",
      svg: {
        fill: shape === "square" ? squareColorLight : circleColor,
        stroke: shape === "square" ? squareColorLight : circleColor,
        opacity: iconOpacity,
        width: "100%"
      }
    },
    label: __spreadProps(__spreadValues({}, theme.typography[loadingIconSizeVariants[size].labelTypographyVariant]), {
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      paddingTop: loadingIconSizeVariants[size].labelPaddingTop
    }),
    center: {
      animation: `${paperCenterAnimation(
        squareColorLight,
        squareColorDark
      )} ${animationFullDuration}ms linear infinite`
    },
    "corner-top-left": __spreadValues({
      transformOrigin: "25% 25%",
      animation: `${paperFoldAnimation(
        -1,
        squareColorLight,
        squareColorMedium,
        squareColorDark
      )} ${animationFullDuration}ms linear infinite`
    }, cornerAnimation),
    "corner-top-right": __spreadValues({
      transformOrigin: "75% 25%",
      animation: `${paperFoldAnimation(
        1,
        squareColorLight,
        squareColorMedium,
        squareColorDark
      )} ${animationFullDuration}ms linear ${animationFrameDuration * 2}ms infinite`
    }, cornerAnimation),
    "corner-bottom-right": __spreadValues({
      transformOrigin: "75% 75%",
      animation: `${paperFoldAnimation(
        -1,
        squareColorLight,
        squareColorMedium,
        squareColorDark
      )} ${animationFullDuration}ms linear ${animationFrameDuration * 4}ms infinite`
    }, cornerAnimation),
    "corner-bottom-left": __spreadValues({
      transformOrigin: "25% 75%",
      animation: `${paperFoldAnimation(
        1,
        squareColorLight,
        squareColorMedium,
        squareColorDark
      )} ${animationFullDuration}ms linear ${animationFrameDuration * 6}ms infinite`
    }, cornerAnimation),
    // Used for IE 11 to display a simple icon since animated svg's dont work
    "pulse-icon": {
      fontSize: loadingIconSizeVariants[size].fontSize,
      color: squareColorMedium
    },
    "circle-icon": {
      cx: loadingIconSizeVariants[size].circleCx,
      cy: loadingIconSizeVariants[size].circleCy,
      r: loadingIconSizeVariants[size].circleRadius,
      strokeWidth: loadingIconSizeVariants[size].circleStroke,
      fill: "transparent",
      animation: `${spinAnimation} 3s ease-in-out infinite`,
      transform: "rotate(-90deg)",
      transformOrigin: "50% 50%",
      strokeDasharray: circleCircumference
    }
  };
}
var loadingIconSizeVariants = {
  sm: {
    squareDimensionWidth: "16px",
    squareDimensionHeight: "16px",
    circleRadius: "24px",
    circleStroke: "8px",
    circleCx: "32px",
    circleCy: "32px",
    circleDimensionWidth: "24px",
    circleDimensionHeight: "24px",
    labelPaddingTop: "12px",
    labelTypographyVariant: "body03",
    fontSize: "16px"
  },
  md: {
    squareDimensionWidth: "32px",
    squareDimensionHeight: "32px",
    circleRadius: "48px",
    circleStroke: "10px",
    circleCx: "58px",
    circleCy: "58px",
    circleDimensionWidth: "48px",
    circleDimensionHeight: "48px",
    labelPaddingTop: "14px",
    labelTypographyVariant: "body02",
    fontSize: "32px"
  },
  lg: {
    squareDimensionWidth: "64px",
    squareDimensionHeight: "64px",
    circleRadius: "64px",
    circleStroke: "12px",
    circleCx: "76px",
    circleCy: "76px",
    circleDimensionWidth: "64px",
    circleDimensionHeight: "64px",
    labelPaddingTop: "18px",
    labelTypographyVariant: "body02",
    fontSize: "64px"
  }
};

// components/loading/common/src/loading-icon-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-loading-icon";
var getLoadingIconClasses = (props) => {
  const { cssClasses, overrideClasses, className } = props;
  return cx(cssClasses.root, className, overrideClasses && overrideClasses.root, globalClassName);
};
var getLoadingIconPulseClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses["pulse-icon"],
    overrideClasses && overrideClasses["pulse-icon"],
    `${globalClassName}__pulse-icon`
  );
};
var getLoadingIconPointClasses = (props) => {
  const { cssClasses, overrideClasses, point } = props;
  return point === "center" ? cx(
    cssClasses.center,
    overrideClasses && overrideClasses.center,
    `${globalClassName}__center`
  ) : cx(
    cssClasses[point],
    overrideClasses && overrideClasses[point],
    `${globalClassName}__${point}`
  );
};
var getLoadingIconLabelClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.label,
    overrideClasses && overrideClasses.label,
    `${globalClassName}__label`
  );
};
var getLoadingIconCircleClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses["circle-icon"],
    overrideClasses && overrideClasses["circle-icon"],
    `${globalClassName}circle-icon`
  );
};
var getCircleIconSvgAttributes = (props) => {
  const { size = loadingIconDefaultProps.size } = props;
  const svgSize = circleSvgSizeVariants[size].svgSize;
  const viewBox = circleSvgSizeVariants[size].viewBox;
  return { svgSize, viewBox };
};
var getSquareIconSvgAttributes = (props) => {
  const { size = loadingIconDefaultProps.size } = props;
  const svgSize = squareSvgSizeVariants[size].svgSize;
  const viewBox = squareSvgSizeVariants[size].viewBox;
  return { svgSize, viewBox };
};
var circleSvgSizeVariants = {
  sm: {
    svgSize: "24px",
    viewBox: "0 0 64 64"
  },
  md: {
    svgSize: "48px",
    viewBox: "0 0 116 116"
  },
  lg: {
    svgSize: "64px",
    viewBox: "0 0 152 152"
  }
};
var squareSvgSizeVariants = {
  sm: {
    svgSize: "16px",
    viewBox: "0 0 100 100"
  },
  md: {
    svgSize: "32px",
    viewBox: "0 0 100 100"
  },
  lg: {
    svgSize: "64px",
    viewBox: "0 0 100 100"
  }
};

// components/loading/common/src/loading-overlay-props.ts
var loadingOverlayDefaultProps = {
  visible: false,
  fullScreen: false
};

// components/loading/common/src/loading-overlay-style-sheet.ts
import { rgba } from "polished";
import { zIndex } from "@gs-ux-uitoolkit-common/design-system";
import { StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions2 } from "@gs-ux-uitoolkit-common/theme";
var loadingOverlayStyleSheet = new StyleSheet2(
  "loading-overlay",
  (props) => {
    var _a;
    return createComponentClassDefinitions2(props, createDefaultStyledClasses2, (_a = props.theme.styleOverrides) == null ? void 0 : _a.loadingOverlay);
  }
);
function createDefaultStyledClasses2({
  theme,
  fullScreen,
  visible
}) {
  return {
    root: {
      position: fullScreen ? "fixed" : "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      backgroundColor: rgba(theme.surface.primary, 0.75),
      display: visible ? "flex" : "none",
      zIndex: fullScreen ? zIndex.overlayFixed : zIndex.overlay,
      "> div, > gs-loading-icon": {
        margin: "auto"
      }
    }
  };
}

// components/loading/common/src/loading-overlay-util.ts
import { cx as cx2 } from "@gs-ux-uitoolkit-common/style";
var getLoadingOverlayClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx2(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    "gs-loading-overlay"
  );
};
export {
  getCircleIconSvgAttributes,
  getLoadingIconCircleClasses,
  getLoadingIconClasses,
  getLoadingIconLabelClasses,
  getLoadingIconPointClasses,
  getLoadingIconPulseClasses,
  getLoadingOverlayClasses,
  getSquareIconSvgAttributes,
  loadingIconColorNames,
  loadingIconDefaultLabelText,
  loadingIconDefaultProps,
  loadingIconShapes,
  loadingIconSizes,
  loadingIconStyleSheet,
  loadingOverlayDefaultProps,
  loadingOverlayStyleSheet
};
//# sourceMappingURL=index.mjs.map
